    <div class="modal fade" id="newTaskStep" tabindex="-1" role="dialog" aria-labelledby="newTaskStepLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h5 class="modal-title"> 
                    <strong ng-if="task_step.id"> KargoAdımı Düzenle</strong>
                    <strong ng-if="!task_step.id"> Yeni Kargo Adımı Ekle</strong>
                </h5>
            </div>
            <form ng-submit="saveTaskStep()" class="form-horizontal allcp-form">
            <div class="modal-body">
                <div class="form-group">
                    <label class="col-md-3 control-label">Adım Adı * : </label>
                    <div class="col-md-9">
                        <label for="name21" class="field prepend-icon">
                            <input type="text" ng-model="task_step.name" class="gui-input br-light light" placeholder="Adım Adı" required>
                            <label for="name21" class="field-icon">
                                <i class="fa fa-list-alt"></i>
                            </label>
                        </label>
                    </div>
                </div>

                <div class="form-group">
                    <label class="col-md-3 control-label">Renk * : </label>
                    <div class="col-md-9">
                        <ul class="color-palette" >
                            <li 
                                ng-repeat="color in colorList"
                                ng-style="{'background-color': color }"
                                class="color-selected" 
                                ng-click="task_step.color = color" 
                                ng-class="task_step.color == color ? 'selected' : ''">
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Vazgeç</button>
                    <button type="submit" class="btn btn-primary" ng-if="!task_step.id">Ekle</button>
                    <button type="submit" class="btn btn-warning" ng-if="task_step.id">Güncelle</button>
                </div>
            </form>
            
            </div>
        </div>
    </div>

    <div class="modal fade" id="deleteTask" tabindex="-1" role="dialog" aria-labelledby="deleteTaskLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h5 class="modal-title"> <strong> Dikkat!</strong></h5>
            </div>
            <div class="modal-body">
                <strong class="text-danger">
                    <i class="fa fa-exclamation-triangle"></i> Yapacağınız silme işlemi geri alınamaz bir işlemdir.
                </strong>
                <p><strong>Silmek istediğinizden emin misiniz ? </strong> </p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="modal">Vazgeç</button>
                <button type="button" class="btn btn-danger" ng-click="deleteTaskStep('','delete')" data-dismiss="modal">Sil</button>
            </div>
            </div>
        </div>
    </div>